import { render, staticRenderFns } from "./AppCase.vue?vue&type=template&id=6a362a48&scoped=true&"
import script from "./AppCase.vue?vue&type=script&lang=ts&"
export * from "./AppCase.vue?vue&type=script&lang=ts&"
import style0 from "./AppCase.vue?vue&type=style&index=0&id=6a362a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a362a48",
  null
  
)

export default component.exports